'use client'
import PlatformForm from './PlatformForm'
import withFormProviders from '@/donationPages/_dependencies/components/withFormProviders'
const PlatformFormWithProviders = withFormProviders(PlatformForm)
export default PlatformFormWithProviders
